import { axios } from '@/services/axios';

const updateTrigger = async ({ updatedTrigger, currentScope }) => {
    const res = await axios.put('/Trigger', updatedTrigger, {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res.data;
};

export default updateTrigger;
